<template>
  <header :class="classList">
    <slot>Header</slot>
  </header>
</template>

<script>
export default {
  name: "AppHeader",
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classList() {
      return ["app-header", "navbar"];
    },
  },
  mounted() {
    this.isFixed(this.fixed);
  },
  methods: {
    isFixed(fixed) {
      fixed
        ? document.body.classList.add("header-fixed")
        : document.body.classList.remove("header-fixed");
      return fixed;
    },
  },
};
</script>
<style scoped>
.eb-navbar-brand {
  margin-left: -16px;
  margin-top: -8px;
  width: 215px !important;
  background: #fff;
  color: #fafbfe;
  height: 48px !important;
}
.app-header {
  height: 65px;
  border: 0px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
}
</style>
